// Configuracao base da API
// const rawBaseUrl = 'http://127.0.0.1:8000/'
const rawBaseUrl = 'https://042.iapotech.com.br/'
const normalizedBaseUrl = rawBaseUrl.startsWith('http://') || rawBaseUrl.startsWith('https://')
  ? rawBaseUrl
  : `http://${rawBaseUrl}`;

export const DOMINIO = normalizedBaseUrl.replace(/\/+$/, '');
export const BASE_URL = `${DOMINIO}/api`;

if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line no-console
  console.log('[API CONFIG] REACT_APP_BASE_URL:', rawBaseUrl);
  // eslint-disable-next-line no-console
  console.log('[API CONFIG] BASE_URL:', BASE_URL);
}

// Alias para compatibilidade
export const API_URL = BASE_URL;

// ==================== AUTENTICACAO ====================
export const API_LOGIN = `${BASE_URL}/auth/token/`;
export const API_REFRESH_TOKEN = `${BASE_URL}/auth/token/refresh/`;
export const API_TOKEN_VERIFY = `${BASE_URL}/auth/token/verify/`;
export const API_PROFILE = `${BASE_URL}/auth/profile/`;
export const API_REGISTER = `${BASE_URL}/auth/register/`;
export const API_ME_OPERATIONS = `${BASE_URL}/me/operations/`;
export const API_ME_FEATURES = `${BASE_URL}/me/features/`;
export const API_ME_MENU = `${BASE_URL}/me/menu/`;

// ==================== HEALTH & DOCS ====================
export const API_HEALTH = `${BASE_URL}/health/`;
export const API_DOCS = `${BASE_URL}/docs/`;
export const API_REDOC = `${BASE_URL}/redoc/`;
export const API_SCHEMA = `${BASE_URL}/schema/`;

// ==================== USUARIOS & GRUPOS ====================
export const API_USERS = `${BASE_URL}/users/`;
export const API_USER_DETAIL = (id: number | string) => `${BASE_URL}/users/${id}/`;
export const API_GROUPS = `${BASE_URL}/groups/`;
export const API_GROUP_DETAIL = (id: number | string) => `${BASE_URL}/groups/${id}/`;
export const API_OPERATIONS = `${BASE_URL}/operations/`;
export const API_OPERATION_DETAIL = (id: number | string) => `${BASE_URL}/operations/${id}/`;
export const API_FEATURES = `${BASE_URL}/features/`;
export const API_FEATURE_DETAIL = (id: number | string) => `${BASE_URL}/features/${id}/`;
export const API_MENU_ITEMS = `${BASE_URL}/menu-items/`;
export const API_MENU_ITEM_DETAIL = (id: number | string) => `${BASE_URL}/menu-items/${id}/`;

// ==================== PERMISSOES ====================
export const API_PERMISSIONS = `${BASE_URL}/permissions/`;
export const API_PERMISSION_DETAIL = (id: number | string) => `${BASE_URL}/permissions/${id}/`;
export const API_ROLES = `${BASE_URL}/roles/`;
export const API_ROLE_DETAIL = (id: number | string) => `${BASE_URL}/roles/${id}/`;
export const API_USER_ROLES = `${BASE_URL}/user-roles/`;
export const API_USER_ROLE_DETAIL = (id: number | string) => `${BASE_URL}/user-roles/${id}/`;
export const API_AUDIT_LOGS = `${BASE_URL}/audit-logs/`;
export const API_AUDIT_LOG_DETAIL = (id: number | string) => `${BASE_URL}/audit-logs/${id}/`;

// ==================== LOGS ====================
export const API_LOGS = `${BASE_URL}/audit-logs/`;
export const API_LOG_DETAIL = (id: number | string) => `${BASE_URL}/audit-logs/${id}/`;

// ==================== MADEIRAS ====================
export const API_MADEIRAS = `${BASE_URL}/madeiras/`;
export const API_MADEIRA_DETAIL = (id: number | string) => `${BASE_URL}/madeiras/${id}/`;

// ==================== PESSOAS ====================
const PESSOAS_API = `${BASE_URL}/pessoas`;
export const API_ENTIDADES = `${PESSOAS_API}/entidades/`;
export const API_TIPOS_ENTIDADE = `${PESSOAS_API}/tipos-entidade/`;
export const API_UF = `${PESSOAS_API}/uf/`;
export const API_CIDADES = `${PESSOAS_API}/cidades/`;
export const API_ENDERECOS = `${PESSOAS_API}/enderecos/`;
export const API_OPERADORES = `${PESSOAS_API}/operadores/`;
export const API_TREINAMENTOS = `${PESSOAS_API}/treinamentos/`;
export const API_PRODUTIVIDADE_OPERADORES = `${PESSOAS_API}/produtividade-operadores/`;

// Consultas de Pessoas (filtradas por tipo)
const PESSOAS_CONSULTAS_API = `${PESSOAS_API}/consultas`;
export const API_CONSULTA_CLIENTES = `${PESSOAS_CONSULTAS_API}/clientes/`;
export const API_CONSULTA_FORNECEDORES = `${PESSOAS_CONSULTAS_API}/fornecedores/`;
export const API_CONSULTA_COLABORADORES = `${PESSOAS_CONSULTAS_API}/colaboradores/`;

// ==================== AQUISICAO ====================
const AQUISICAO_API = `${BASE_URL}/aquisicao`;
export const API_TRATAMENTOS_MADEIRA = `${AQUISICAO_API}/tratamentos-madeira/`;
export const API_TIPOS_MADEIRA = `${AQUISICAO_API}/tipos-madeira/`;
export const API_CERTIFICACOES = `${AQUISICAO_API}/certificacoes/`;
export const API_TIPOS_TRATAMENTO = `${AQUISICAO_API}/tipos-tratamento/`;
export const API_UNIDADES_MEDIDA = `${AQUISICAO_API}/unidades-medida/`;

// Aliases para compatibilidade
export const API_FORNECEDORES = API_CONSULTA_FORNECEDORES; // Usar entidades com filtro tipo=FORNECEDOR
export const API_COMPRAS_MADEIRA = `${AQUISICAO_API}/compras-madeira/`;
export const API_ITENS_COMPRA_MADEIRA = `${AQUISICAO_API}/itens-compra-madeira/`;
export const API_LOTES_MADEIRA = `${AQUISICAO_API}/lotes-madeira/`;
export const API_ESTOQUE_MADEIRA = `${AQUISICAO_API}/estoque-madeira/`;

// ==================== ESTOQUE ====================
const ESTOQUE_API = `${BASE_URL}/estoque`;

// Cadastros Base
export const API_ARMAZENS = `${ESTOQUE_API}/armazens/`;
export const API_CATEGORIAS_PRODUTO = `${ESTOQUE_API}/categorias-produto/`;

// Produtos (catalogo)
export const API_PRODUTOS = `${ESTOQUE_API}/produtos/`;
export const API_CATALOGO_PRODUTOS = API_PRODUTOS; // Alias

// Movimentações
export const API_MOVIMENTACOES_PRODUTOS = `${ESTOQUE_API}/movimentacoes-produtos/`;
export const API_CONTAGENS_ESTOQUE = `${ESTOQUE_API}/contagens-estoque/`;

// Consultas de Estoque
const ESTOQUE_CONSULTAS_API = `${ESTOQUE_API}/consultas`;
export const API_ESTOQUE_PRODUTOS = `${ESTOQUE_CONSULTAS_API}/estoque-produtos/`;
export const API_PRODUTOS_ETIQUETAS = `${ESTOQUE_CONSULTAS_API}/produtos-etiquetas/`;
export const API_DISPONIBILIDADE_SAIDA = `${ESTOQUE_API}/disponibilidade-saida/`;
export const API_PRODUTOS_PARA_VENDA = `${ESTOQUE_CONSULTAS_API}/produtos-para-venda/`;
export const API_PRODUTOS_COM_LOTE = `${ESTOQUE_CONSULTAS_API}/produtos-com-lote/`;
export const API_LOTES_POR_PRODUTO = `${ESTOQUE_CONSULTAS_API}/lotes-por-produto/`;

// Clientes e Expedição
export const API_CLIENTES = API_CONSULTA_CLIENTES; // Usar entidades com filtro tipo=CLIENTE
export const API_PEDIDOS_EXPEDICAO = `${ESTOQUE_API}/pedidos-expedicao/`;
export const API_EXPEDICOES = `${ESTOQUE_API}/expedicoes/`;
export const API_PLANEJAMENTO_CARGAS = `${ESTOQUE_API}/planejamento-cargas/`;
export const API_ITENS_CARGA = `${ESTOQUE_API}/itens-carga/`;

// Deprecated (manter por compatibilidade)
export const API_TIPOS_PRODUTO = API_CATEGORIAS_PRODUTO;

// ==================== FICHAS TECNICAS ====================
const FICHAS_TECNICAS_API = `${BASE_URL}/fichas-tecnicas`;
const FICHAS_TECNICAS_FICHAS_BASE = `${FICHAS_TECNICAS_API}/fichas`;
export const API_FICHAS_TECNICAS = `${FICHAS_TECNICAS_FICHAS_BASE}/`;
export const API_FICHAS_TECNICAS_DETAIL = (id: number | string) =>
  `${FICHAS_TECNICAS_FICHAS_BASE}/${id}/`;
export const API_FICHAS_TECNICAS_INSUMOS = (id: number | string) =>
  `${FICHAS_TECNICAS_FICHAS_BASE}/${id}/insumos/`;
export const API_FICHAS_TECNICAS_SUBPRODUTOS = (id: number | string) =>
  `${FICHAS_TECNICAS_FICHAS_BASE}/${id}/subprodutos/`;
export const API_FICHAS_TECNICAS_SUBPROCESSOS = (id: number | string) =>
  `${FICHAS_TECNICAS_FICHAS_BASE}/${id}/subprocessos/`;
export const API_FICHAS_TECNICAS_CUSTO_DETALHADO = (id: number | string) =>
  `${FICHAS_TECNICAS_FICHAS_BASE}/${id}/custo-detalhado/`;

// ==================== PRODUCAO ====================
const PRODUCAO_API = `${BASE_URL}/producao`;
export const API_TIPOS_MAQUINA = `${PRODUCAO_API}/tipos-maquina/`;
export const API_MAQUINAS = `${PRODUCAO_API}/maquinas/`;
export const API_ORDENS_PRODUCAO = `${PRODUCAO_API}/ordens-producao/`;
export const API_PRODUCAO_DIMENSIONAL = `${PRODUCAO_API}/producao-dimensional/`;

// Deprecated (remover referências antigas se existirem)
export const API_COMPONENTES_PRODUTO = `${PRODUCAO_API}/componentes-produto/`; // Usar Fichas Técnicas
export const API_ITENS_ORDEM_PRODUCAO = `${PRODUCAO_API}/itens-ordem-producao/`;
export const API_ETAPAS_PRODUCAO = `${PRODUCAO_API}/etapas-producao/`;
export const API_APONTAMENTOS_PRODUCAO = `${PRODUCAO_API}/apontamentos-producao/`;
export const API_CONSUMO_MADEIRA = `${PRODUCAO_API}/consumos-madeira/`;
export const API_CONTAGENS_DIARIAS = `${PRODUCAO_API}/contagens-diarias/`;
export const API_DIAS_TRABALHO = `${PRODUCAO_API}/dias-trabalho/`;
export const API_DIA_TRABALHO_RELATORIO = (id: number | string) =>
  `${PRODUCAO_API}/dias-trabalho/${id}/relatorio/`;

// ==================== QUALIDADE ====================
const QUALIDADE_API = `${BASE_URL}/qualidade`;
export const API_INSPECOES = `${QUALIDADE_API}/inspecoes/`;
export const API_DEFEITOS_CATALOGO = `${QUALIDADE_API}/defeitos-catalogo/`;
export const API_DEFEITOS = `${QUALIDADE_API}/defeitos/`;
export const API_RETRABALHOS = `${QUALIDADE_API}/retrabalhos/`;

// ==================== MANUTENCAO ====================
const MANUTENCAO_API = `${BASE_URL}/manutencao`;
export const API_MAQUINAS_MANUTENCAO = `${MANUTENCAO_API}/maquinas/`;
export const API_ORDENS_MANUTENCAO = `${MANUTENCAO_API}/ordens-manutencao/`;
export const API_HISTORICO_MANUTENCAO = `${MANUTENCAO_API}/historico-manutencao/`;

// ==================== INDICADORES ====================
const INDICADORES_API = `${BASE_URL}/indicadores`;
export const API_KPIS = `${INDICADORES_API}/kpis/`;
export const API_METRICAS_KPI = `${INDICADORES_API}/metricas/`;
export const API_RELATORIOS_PRODUTIVIDADE = `${INDICADORES_API}/relatorios-produtividade/`;

// Deprecated
export const API_CONSOLIDACAO_DIARIA = `${INDICADORES_API}/consolidacao-diaria/`;

// ==================== CUSTOS ====================
const CUSTOS_API = `${BASE_URL}/custos`;
export const API_CUSTOS_PADRAO = `${CUSTOS_API}/custos-padrao/`;
export const API_CUSTOS_REAIS = `${CUSTOS_API}/custos-reais/`;
export const API_VARIACOES_CUSTO = `${CUSTOS_API}/variacoes-custo/`;

// ==================== INTEGRACAO FINANCEIRA ====================
const INTEGRACAO_API = `${BASE_URL}/integracao-financeira`;
export const API_LANCAMENTOS_ESTOQUE = `${INTEGRACAO_API}/lancamentos-estoque/`;
export const API_DOCUMENTOS_CONTABEIS = `${INTEGRACAO_API}/documentos-contabeis/`;
export const API_WEBHOOKS_ERP = `${INTEGRACAO_API}/webhooks-erp/`;

// ==================== OTIMIZACAO ====================
const OTIMIZACAO_API = `${BASE_URL}/otimizacao`;
export const API_PLANEJAR_CARGA = `${OTIMIZACAO_API}/planejar-carga/`;

// ==================== MENSAGERIA ====================
const MENSAGERIA_API = `${BASE_URL}/mensageria`;
export const API_MENSAGENS = `${MENSAGERIA_API}/mensagens/`;
export const API_DELIVERIES = `${MENSAGERIA_API}/deliveries/`;
export const API_DELIVERIES_UNREAD_TOTAL = `${API_DELIVERIES}unread_total/`;

// ==================== LOGISTICA ====================
const LOGISTICA_API = `${BASE_URL}/logistica`;
export const API_VEICULOS = `${LOGISTICA_API}/veiculos/`;
export const API_ACOPLAMENTOS = `${LOGISTICA_API}/acoplamentos/`;
export const API_ORDENS_SERVICO = `${LOGISTICA_API}/ordens-servico/`;
export const API_ORDENS_TRANSPORTE = `${LOGISTICA_API}/ordens-transporte/`;
export const API_CHECKLIST_TEMPLATES = `${LOGISTICA_API}/checklist-templates/`;
export const API_CHECKLISTS = `${LOGISTICA_API}/checklists/`;

// ==================== ETIQUETAS ====================
const ETIQUETAS_API = `${BASE_URL}/etiquetas`;
export const API_ETIQUETAS_GERADAS = `${ETIQUETAS_API}/geradas/`;
export const API_ETIQUETAS_GERAR = `${ETIQUETAS_API}/geradas/gerar/`;
export const API_ETIQUETAS_TAMANHOS = `${ETIQUETAS_API}/geradas/tamanhos/`;
export const API_ETIQUETAS_DOWNLOAD = (id: number | string) => `${ETIQUETAS_API}/geradas/${id}/download/`;
export const API_ETIQUETAS_PREVIEW = (id: number | string) => `${ETIQUETAS_API}/geradas/${id}/preview/`;
export const API_ETIQUETAS_MODELOS = `${ETIQUETAS_API}/modelos/`;

// ==================== INVENTARIO ====================
const INVENTARIO_API = `${BASE_URL}/inventario`;
export const API_INVENTARIOS = `${INVENTARIO_API}/inventarios/`;
export const API_INVENTARIO_ITENS = `${INVENTARIO_API}/itens/`;
export const API_INVENTARIO_ADICIONAR_ITENS = (id: number | string) => `${INVENTARIO_API}/inventarios/${id}/itens/`;
export const API_INVENTARIO_VALIDAR_BARCODE = `${INVENTARIO_API}/inventarios/validar-barcode/`;

// ==================== IMPORTS ====================
export const API_IMPORTS_PRODUTOS = `${ESTOQUE_API}/importar-produtos/`;
export const API_IMPORTS_ENTRADAS = `${ESTOQUE_API}/importar-entradas/`;
export const API_IMPORTS_SAIDAS = `${ESTOQUE_API}/importar-saidas/`;
export const API_IMPORTS_ORDENS_PRODUCAO = `${PRODUCAO_API}/importar-ordens-producao/`;

const IMPORTS_API = `${BASE_URL}/imports`;
export const API_IMPORTS_HISTORICO = `${IMPORTS_API}/historico/`;
